import { createContext } from 'react';
import Group from '@/lib/constants/Group.enum';

const VisiblePortfolioTemplatesGroupContext = createContext<Group>(
  Group.STUDENTS,
);

export default VisiblePortfolioTemplatesGroupContext;
